export default [
  'colleagueAskMe',
  'emailApplication',
  'SMSApplication',
  'generalAdv',
  'dailyReport',
  'weeklyReport',
];
